import StoreblocksDatepicker, { Props } from "@storeblocks/datepicker";
import { Field, FieldProps } from "formik";

import { WrapLgMarginBottom } from "App/global-style";
import { useTexts } from "Components/TextContext";
import { Button } from "Components/TextContext/commonComponentEnums";
import { isDefined } from "Utils/functions";
import { endOfToday, startOfToday } from "date-fns";
import addMonths from "date-fns/addMonths";
import React from "react";

type DatePickerProps = Omit<Props, "onChange"> &
  Partial<Pick<Props, "onChange">>;

export const Datepicker = ({
  error,
  hint,
  id,
  label,
  name,
  max = addMonths(endOfToday(), 3),
  min = startOfToday(),
  clearable,
  small,
  medium,
  onChange,
  large,
  locale = "nb",
  inputProps,
}: DatePickerProps): React.ReactElement => {
  const { getText } = useTexts();
  return (
    <Field name={name}>
      {({ field, form }: FieldProps) => (
        <WrapLgMarginBottom>
          <StoreblocksDatepicker
            {...field}
            id={id}
            label={label}
            hint={hint}
            max={max}
            min={min}
            error={error}
            onChange={(event, selected) => {
              isDefined(onChange) && onChange(event, selected);
              form.setFieldTouched(name);
              form.setFieldValue(name, selected);
            }}
            iconButtonProps={{
              "aria-label": getText("arialabel.datepicker.open"),
            }}
            clearable={clearable}
            clearLabel={clearable ? getText(Button.CLOSE) : undefined}
            small={small}
            medium={medium}
            large={large}
            locale={locale}
            inputProps={inputProps}
          />
        </WrapLgMarginBottom>
      )}
    </Field>
  );
};
